const WISHLIST_KEY = 'buqiqi_wishlist_handles';

const getWishlist = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');

    if (!Array.isArray(saved)) return [];

    return [...new Set(saved.filter((handle) => typeof handle === 'string' && handle))];
  } catch {
    return [];
  }
};

const saveWishlist = (handles) => {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify([...new Set(handles)]));
    window.dispatchEvent(new CustomEvent('wishlist:updated'));
  } catch {
    // Browser storage unavailable.
  }
};

const hasProduct = (handle) => getWishlist().includes(handle);

const updateCount = () => {
  const count = getWishlist().length;

  document.querySelectorAll('[data-wishlist-count]').forEach((element) => {
    const text = element.querySelector('[data-wishlist-count-text]');

    if (text) {
      text.textContent = count;
    } else {
      element.textContent = count;
    }

    element.hidden = count === 0;
  });

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const isActive = hasProduct(button.dataset.productHandle);

    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
    button.setAttribute(
      'aria-label',
      isActive ? 'Remove from wishlist' : 'Add to wishlist'
    );
  });
};

const toggleProduct = (handle) => {
  if (!handle) return;

  const handles = getWishlist();
  const index = handles.indexOf(handle);

  if (index === -1) {
    handles.push(handle);
  } else {
    handles.splice(index, 1);
  }

  saveWishlist(handles);
};

const escapeHtml = (value) =>
  String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

const money = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';

  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency,
  }).format(Number(cents || 0) / 100);
};

const emptyWishlistMarkup = () => `
  <div class="wishlist-page__empty">
    <p>Your wishlist is empty.</p>
    <a class="button" href="/collections/all">Continue shopping</a>
  </div>
`;

const productCard = (product) => {
  const title = escapeHtml(product.title);
  const image = product.featured_image || product.images?.[0] || '';
  const productUrl = product.url || `/products/${encodeURIComponent(product.handle)}`;

  const imageMarkup = image
    ? `<img src="${escapeHtml(image)}" alt="${title}" loading="lazy">`
    : '';

  return `
    <article class="wishlist-page__item">
      <a class="wishlist-page__image" href="${escapeHtml(productUrl)}">
        ${imageMarkup}
      </a>

      <a class="wishlist-page__title" href="${escapeHtml(productUrl)}">
        ${title}
      </a>

      <div class="wishlist-page__price">${money(product.price)}</div>

      <button
        class="wishlist-page__remove"
        type="button"
        data-wishlist-remove="${escapeHtml(product.handle)}"
      >
        Remove
      </button>
    </article>
  `;
};

const renderWishlistPage = async () => {
  const container = document.querySelector('[data-wishlist-products]');
  if (!container) return;

  const handles = getWishlist();

  if (!handles.length) {
    container.innerHTML = emptyWishlistMarkup();
    return;
  }

  container.innerHTML = '<p>Loading your favorites…</p>';

  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');

  const products = await Promise.all(
    handles.map(async (handle) => {
      try {
        const response = await fetch(
          `${root}/products/${encodeURIComponent(handle)}.js`
        );

        return response.ok ? response.json() : null;
      } catch {
        return null;
      }
    })
  );

  const availableProducts = products.filter(Boolean);

  // 商品已删除或已无法获取时，自动从收藏中移除。
  if (availableProducts.length !== handles.length) {
    saveWishlist(availableProducts.map((product) => product.handle));
  }

  container.innerHTML = availableProducts.length
    ? availableProducts.map(productCard).join('')
    : emptyWishlistMarkup();
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');

  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    toggleProduct(toggle.dataset.productHandle);
    return;
  }

  const remove = event.target.closest('[data-wishlist-remove]');

  if (remove) {
    toggleProduct(remove.dataset.wishlistRemove);
    renderWishlistPage();
  }
});

window.addEventListener('wishlist:updated', updateCount);

document.addEventListener('DOMContentLoaded', () => {
  updateCount();
  renderWishlistPage();
});